import compose from 'recompose/compose';
import fromRenderProps from 'recompose/fromRenderProps';
import pure from 'recompose/pure';
import setHOCDisplayName from "../service/setHOCDisplayName";
import ErrorContext from "../service/ErrorContext";
var ErrorContextConsumer = ErrorContext.Consumer;
var withErrorConsumer = compose(setHOCDisplayName('withErrorConsumer'), fromRenderProps(ErrorContextConsumer, function (contextValue) {
  return {
    errorHandler: contextValue
  };
}), pure);
export default withErrorConsumer;